import { MAX_SENDER_NAME_LENGTH } from "./constants";
import { sanitizeAdminImages } from "./sanitize-images";
import { AdminMessage } from "./types";

/**
 * Makes an admin reply from the server safe to render: only https images are
 * kept, and the sender's name is capped so a compromised Slack display name
 * can't disrupt the UI or spoof an oversized brand string.
 *
 * @param payload - The reply as the socket or the thread endpoint sent it.
 * @returns The reply to store, or null when nothing would render (no text and no surviving image).
 */
export const toSafeAdminMessage = (payload: AdminMessage): AdminMessage | null => {
  const { images, ...rest } = payload;
  const safeImages = sanitizeAdminImages(images);
  if (!rest.text?.trim() && !safeImages) return null;
  return {
    ...rest,
    kind: "admin",
    ...(safeImages && { images: safeImages }),
    sender: {
      ...payload.sender,
      name: payload.sender?.name?.slice(0, MAX_SENDER_NAME_LENGTH) || "Support",
    },
  };
};
